/** Worker-thread shutdown flag (main-thread {@link isCliImmediateShutdownRequested} is not visible in workers). */
let symbolIndexWorkerShutdownRequested = false;

export function requestSymbolIndexWorkerShutdown(): void {
  symbolIndexWorkerShutdownRequested = true;
}

export function isSymbolIndexWorkerShutdownRequested(): boolean {
  return symbolIndexWorkerShutdownRequested;
}

export function resetSymbolIndexWorkerShutdownForTests(): void {
  symbolIndexWorkerShutdownRequested = false;
}

/** True when symbol-index work should stop (main Ctrl+C or worker shutdown message). */
export function isSymbolIndexWorkInterrupted(): boolean {
  return symbolIndexWorkerShutdownRequested;
}
